module.exports = __webpack_public_path__ + "img/信用等级.c0fe818f.jpg";